/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Situationpolishdetails2Inputs */

const en_situationpolishdetails2 = /** @type {(inputs: Situationpolishdetails2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polish the details in Data when you have a moment`)
};

const pt_situationpolishdetails2 = /** @type {(inputs: Situationpolishdetails2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine os detalhes em Dados quando tiver um momento`)
};

/**
* | output |
* | --- |
* | "Polish the details in Data when you have a moment" |
*
* @param {Situationpolishdetails2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const situationpolishdetails2 = /** @type {((inputs?: Situationpolishdetails2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Situationpolishdetails2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_situationpolishdetails2(inputs)
	return pt_situationpolishdetails2(inputs)
});
export { situationpolishdetails2 as "situationPolishDetails" }